import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="m12 1.594-.68 1.547L8.883 8.6l-5.953.633-1.688.188 1.266 1.125 4.43 4.008-1.243 5.86-.351 1.64 1.476-.844 5.18-3 5.18 3 1.476.844-.351-1.64-1.242-5.86 4.43-4.008 1.265-1.125-1.688-.188-5.953-.632L12.68 3.14 12 1.594Zm0 3.68 1.922 4.335.187.399.422.047 4.711.492-3.515 3.164-.329.305.094.421.985 4.618-4.102-2.344-.375-.234-.375.234-4.102 2.344.985-4.617.094-.422-.329-.305-3.515-3.164 4.71-.492.423-.047.187-.399L12 5.273Z" />
  </svg>
);

export default icon;
